'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPrinter = function IoPrinter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.6 10c2.2 0 4.4 1.5 4.4 4.3v10.2c0 2.5-2.2 4.3-4.4 4.3h-3.1v8.7h-20v-8.7h-3.1c-2.2 0-4.4-1.9-4.4-4.9v-9.6c0-3 2.2-4.3 4.4-4.3h3.1v-5h20v5h3.1z m-4.3 26.3v-13.8h-17.5v13.8h17.5z m0-26.3v-3.7h-17.5v3.7h17.5z m3.7 5v-1.2h-1.3v1.2h1.3z m-20 11.3v-1.3h15v1.3h-15z m0 3.7v-1.2h15v1.2h-15z m0 3.8v-1.3h15v1.3h-15z' })
        )
    );
};

exports.default = IoPrinter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/printer.js
// module id = 2628
// module chunks = 0